import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import TimelineTodoList from "components/TodoList/TimelineTodoLists/TimelineTodoLists";
import { TimelineContext } from "store/contexts/timelineContext";
import TeamService from "services/TeamService";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useGlobalContext } from "store/contexts/globalContext";
import { useHistory } from "react-router-dom";

const styles = {
  heading: {
    fontWeight: 400,
    display: "flex",
    justifyContent: "center",
    marginBottom: "0px",
    paddingTop: "30px",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default () => {
  const classes = styles;
  const [list, setList] = useState([]);
  const { listId } = useParams();
  const history = useHistory();
  const { teamId } = useTeamActionContext();
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const { ringCentral } = useGlobalContext();

  useEffect(() => {
    (async () => {
      try {
        const response = await TeamService.getSingleList(teamId, listId);
        setList([response?.data?.data]);
        setTotal(1);
        setLoading(false);
      } catch (e) {
        if (ringCentral) {
          history.push(`/ringCentral/teams/${teamId}/noPost/list`);
          return;
        }
        console.error(e);
      }
    })();

    //eslint-disable-next-line
  }, []);

  const updateTodo = (todo) => {
    setList([todo]);
  };

  return (
    <TimelineContext.Provider
      value={{
        updateTodo,
      }}
    >
      <div>
        <h3 style={classes.heading}>Your List</h3>
        {loading && (
          <div style={classes.loaderStyle}>
            <Loader />
          </div>
        )}
        <div>
          {!loading && <TimelineTodoList todoLists={list} total={total} />}
        </div>
      </div>
    </TimelineContext.Provider>
  );
};
